<template>
<div class="message-wrapper">
  <!-- 分页导航 -->
  <div class = "pager">
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="page.currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.totalRecord">
    </el-pagination>
  </div>

  <el-table
    :data="datas"
    style="width: 100%"
    highlight-current-row
    >
    <el-table-column
      label="图片"
      width="180">
      <template slot-scope="scope">
        <el-image
          style="width: 100px; height: 100px"
          :src="scope.row.image_url"
          fit="fill" />
      </template>
    </el-table-column>
    <el-table-column label="标题">
      <template slot-scope="scope">
        <el-link :href="scope.row.content_url" target="_blank">{{scope.row.title}}</el-link>
      </template>
    </el-table-column>

    <el-table-column prop="update_time" label="更新时间"></el-table-column>
  </el-table>

</div>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      page:{
        pageSize: 10, //每页条数,  默认10条
        totalRecord: 0, //总条数
        totalPage: 0, //总页数
        currentPage:1  //当前显示页码
      }
    };
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(){
      const that = this

      let params={
        'currentpage': that.page.currentPage,
        'pagesize': that.page.pageSize
      }
      that.axios.get('/message/listwithpage',{params})
      .then(res =>{
        let {code, data, message} = res;
        if(code===0){
          that.datas = data.list;
          that.page.totalRecord = data.total  //总条数
          that.page.totalPage = data.pages    //总页数
        }else{
          that.$message(message);
        }
      });
    },
    // 修改每页记录数
    sizeChange(val) {
      this.page.pageSize = val
      this.loadData()
    },
    //翻页
    currentChange(val) {
      this.page.currentPage=val
      this.loadData()
    },
  }
}
</script>

<style lang="stylus" scoped>
.message-wrapper
  margin: 40px 40px 50px 40px
  .data-table
    >>> .el-icon-star-on
      font-size: 20px
      color: #bbbbbb
    .selected
      color: red
</style>